import(/* webpackMode: "eager", webpackExports: ["PracticeExamClient"] */ "/vercel/path0/src/app/(marketing)/practice-exams/[slug]/PracticeExamClient.tsx");
